import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';
import { BUGSNAG } from './data/Data';
import packageJson from '../package.json';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  version
} = packageJson;
const {
  hostname
} = window.location;
const stage = hostname.match(/dev|local/) ? 'development' : hostname.match(/stage/) ? 'staging' : 'production';
const bugsnagClient = bugsnag({
  apiKey: BUGSNAG.token,
  appVersion: version,
  beforeSend: function (report) {
    report.app.releaseStage = stage;
  }
});
bugsnagClient.use(bugsnagReact, React);
console.info(`AAA IDP version ${version} ${stage}`);

// wrap your entire app tree in the ErrorBoundary for bug reporting
const ErrorBoundary = bugsnagClient.getPlugin('react');
const container = document.getElementById('root');
const root = createRoot(container);
root.render(/*#__PURE__*/_jsx(ErrorBoundary, {
  children: /*#__PURE__*/_jsx(App, {
    bugsnagClient: bugsnagClient
  })
}));